import { HiAtSymbol } from "react-icons/hi";
import { IoCube } from "react-icons/io5";
import { MdHexagon } from "react-icons/md";
import { PiBirdFill } from "react-icons/pi";

export default [
  {
    title: "Clumsy Bird",
    description: "A bird game",
    image: "/games/clumsybird.png",
    link: "http://ellisonleao.github.io/clumsy-bird/",
    icon: <PiBirdFill /> 
  },
  {
    title: "Hextris",
    description: "An addictive puzzle game inspired by Tetris",
    image: "/games/hextris.png",
    link: "https://hextris.io/",
    icon: <MdHexagon/>
  },
  {
    title: "Untrusted",
    description: "You must enable JavaScript to play Untrusted",
    image: "/games/untrusted.png",
    link: "https://untrustedgame.com/",
    icon: <HiAtSymbol />
  },
  {
    title: "Cuberun",
    description: "Avoid the cubes!",
    image: "/games/cuberun.png",
    link: "https://cuberun.adamkarlsten.com/",
    icon: <IoCube /> 
  },
];
